import { render, staticRenderFns } from "./MainBookCard2.vue?vue&type=template&id=2398d136"
import script from "./MainBookCard2.vue?vue&type=script&lang=js"
export * from "./MainBookCard2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports